var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 12.801 11.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(0 -2.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(0 8.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M11.159,26.909H7.713v1.641H5.087V26.909H1.641A2.448,2.448,0,0,1,0,26.277v3.75a1.646,1.646,0,0,0,1.641,1.641h9.518A1.646,1.646,0,0,0,12.8,30.027v-3.75A2.447,2.447,0,0,1,11.159,26.909Z",
    transform: "translate(0 -26.277)",
    fill: "current",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0 2.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M8.7,5.042V4.55A1.646,1.646,0,0,0,7.057,2.909H5.744A1.646,1.646,0,0,0,4.1,4.55v.492H0V7.012A1.646,1.646,0,0,0,1.641,8.653h9.518A1.646,1.646,0,0,0,12.8,7.012V5.042Zm-1.149,0h-2.3V4.55a.5.5,0,0,1,.492-.492H7.057a.5.5,0,0,1,.492.492Z",
    transform: "translate(0 -2.909)",
    fill: "current",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.6710d5cc890e2ba6fb071e8fa1f6fc05.svg";
export { ForwardRef as ReactComponent };